//import React from the React module.
import React from "react";
import Grid from "@mui/material/Grid";
import Typography  from "@mui/material/Typography";
import  Button  from "@mui/material/Button";

//create component Heading
function List(props) {
  return (
    <Grid size={4}>
      <img class="proImg" src={props.img} alt="icon" />
        <Typography
          color="primary"
          variant="p"
          component="p">
          {props.name} <br></br> {props.desc} <br></br> {props.price} 
        </Typography> 
      <Button variant="outlined" color="primary.dark">Add to cart</Button>
    </Grid>
  );
}

export default List;
